import { useSelector } from 'react-redux'
import { selectFeatureFlagEnabled } from 'features/feature-flags/FeatureFlag.selectors'
import { FeatureFlagEnum } from 'features/feature-flags/FeatureFlag.constants'

export function useLinkPreviewEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.LINK_PREVIEW))
}

export function useClaimedAndUnclaimedWorkingSetsEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.CLAIMED_AND_UNCLAIMED_WORKING_SETS))
}

export function useContactOrgsEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.CONTACT_ORGS))
}

export function useMultiPhonesForIdentitiesEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.MULTI_PHONES_ON_IDENTITIES))
}

export function useShipmentToolEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.SHIPMENT_TOOL))
}

export function useLocationFocusedEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.LOCATION_FOCUSED))
}

export function useSettingsAdminTabsEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.SETTINGS_ADMIN_TABS))
}

export function useContactAndChannelBrowsersEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.CONTACT_AND_CHANNEL_BROWSERS))
}

export function useVflowAccountFilterEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.VFLOW_ACCOUNT_FILTER))
}

export function useEmanifestCaptureToolEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.E_MANIFEST_CAPTURE_TOOL))
}

export function useDevAutomationCommandsEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.DEV_AUTOMATION_COMMANDS))
}

export function useElectronicSignatureRequestEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.ELECTRONIC_SIGNATURE_REQUEST))
}

export function useAppHeaderLogoEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.APP_HEADER_LOGO))
}

export function useRbiDemoEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.RBI_DEMO))
}

export function usePushToTmsEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.PUSH_TO_TMS))
}

export function useFeatureUpdatesEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.FEATURE_UPDATES))
}

export function useOutOfOfficeResponderEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.OUT_OF_OFFICE_RESPONDER))
}

export function useMentionsEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.MENTIONS))
}

export function useMentionsRelEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.MENTIONS_REL))
}

export function useEldDeviceManagementEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.ELD_DEVICE_MANAGEMENT))
}

export function useIndividualOrgNotifyPredicatesEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.INDIVIDUAL_ORG_NOTIFY_PREDICATES))
}

export function useContactEmailsEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.CONTACT_EMAILS))
}

export function useDownloadAsTiffEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.DOWNLOAD_AS_TIFF))
}

export function useCaliforniaMealBreaksEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.CALIFORNIA_MEAL_BREAKS))
}

export function usePosthogEnabled() {
  return useSelector(selectFeatureFlagEnabled(FeatureFlagEnum.POSTHOG))
}
